import React from "react";

import { ContentfulImage, ContentfulImageAmp } from "./../../../../components/ContentfulImage";
import {
  Wrapper,
  Hero,
  HeroBackground,
  HeroHeading,
  HeroTitle,
  Author,
  AuthorName,
  AuthorRole,
} from "./styles";

/**
 * Author Card --
 * Small View
 */
export const AuthorSmall = ({
  author,
  title,
  image,
  eyebrow = "Lists",
  fixed = true,
  noName = false,
  hero = false,
  isAmp = false,
  clientContext = null,
  context = null,
}) => {
  const imgData = image;
  return (
    <Wrapper fixed={fixed}>
      <Hero fixed={fixed} hero={hero}>
        <HeroBackground>
          {isAmp === true && image !== null ? (
            <ContentfulImageAmp
              url={imgData.src.file.url}
              title={imgData.src.title}
              width={400}
              height={Number(imgData.src.file.details.image.height * 400 / imgData.src.file.details.image.width).toFixed(0)}
              clientContext={clientContext}
              context={context}              
            />
          ) : (
            <ContentfulImage
              url={imgData.src.file.url}
              title={imgData.src.title}
              width={400}
              height={Number(imgData.src.file.details.image.height * 400 / imgData.src.file.details.image.width).toFixed(0)}
              clientContext={clientContext}
              context={context}       
            />
          )}
        </HeroBackground>
      </Hero>
      <Author>
        {!noName && <HeroHeading>{eyebrow}</HeroHeading>}
        <HeroTitle noName={noName}>{title}</HeroTitle>
        {!noName && <AuthorName>{author.title}</AuthorName>}
        {!noName && <AuthorRole>{author.subtitle}</AuthorRole>}
      </Author>
    </Wrapper>
  );
};

// const filePropType = propTypes.shape({
//   title: propTypes.string.isRequired,
//   file: propTypes.shape({
//     url: propTypes.string.isRequired,
//   }).isRequired,
// }).isRequired;

// const AuthorPropTypes = {
//   title: propTypes.string.isRequired,
//   eyebrow: propTypes.string,
//   fixed: propTypes.bool,
//   noName: propTypes.bool,
//   hero: propTypes.bool,
//   image: propTypes.shape({
//     src: filePropType,
//   }).isRequired,
//   author: propTypes.shape({
//     title: propTypes.string,
//     subtitle: propTypes.string,
//     avatar: filePropType,
//   }).isRequired,
// };

// AuthorSmall.propTypes = AuthorPropTypes;
// AuthorSmall.defaultProps = {
//   eyebrow: "Lists",
//   fixed: true,
//   noName: false,
//   hero: false,
// };

export default AuthorSmall;
